import {GeometryUtil} from "../../geometry";
import {AbstractTransform, TransformInteractionState} from "../abstract-transform";
import {SnapPoint} from "../../snap";
import {Feature} from "geojson";

export class EditorFeatureTransformTranslate extends AbstractTransform<TransformInteractionState> {
  public getVertexIcon(): string {
    return "map-move";
  }

  public transform(state: TransformInteractionState, e: mapboxgl.MapMouseEvent, snapPoint: SnapPoint) {
    e.lngLat.lng = snapPoint.point[0];
    e.lngLat.lat = snapPoint.point[1];

    let vertexCoordinates = this.originalFeature.getCoordinate(state.dragPath);

    let distance = GeometryUtil.pointsDistance([e.lngLat.lng, e.lngLat.lat], vertexCoordinates);
    let bearing = GeometryUtil.pointsBearing(vertexCoordinates, [e.lngLat.lng, e.lngLat.lat]);

    this.transformedFeature.setCoordinates(
      (GeometryUtil.translate(this.originalFeature.toGeoJSON() as Feature, distance, bearing) as any).geometry.coordinates
    );
  }
}
